import { Column } from 'src/shared/components/Semantic/all'
import { ExternalLink, PaintBucket } from 'lucide-react'
import { capitalize } from 'src/shared/utils'
import { ProductVariantColor_ } from 'src/api/db/apiProductVariantColor'
import { ColorVariantSelector } from 'src/shared/components/ProductGrid/ProductCard/ProductPreview/components/ColorVariantSelector'
import { RefObject } from 'react'
import { paths } from 'src/routes/paths'

export const ProductHeader = ({
  productName,
  product_id,
  chosenColor,
  product_variant_colors,
  scrollContainerRef,
  setProduct_variant_color,
  showLink = false,
}: {
  productName: string
  product_id?: number
  chosenColor: string
  product_variant_colors?: ProductVariantColor_[]
  scrollContainerRef?: RefObject<HTMLDivElement>
  setProduct_variant_color?: (color: ProductVariantColor_) => void
  showLink?: boolean
}) => {
  const productHref =
    showLink && product_id ? `${paths.product}/${product_id}` : null

  return (
    <Column className="gap-2 min-w-0">
      <h2>
        {productHref ? (
          <a
            href={productHref}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            {productName}
            <ExternalLink className="inline w-3 h-3 align-middle mb-1 ml-2 text-muted-foreground" />
          </a>
        ) : (
          productName
        )}
      </h2>

      <div className="flex items-center gap-1">
        <PaintBucket className="w-3 h-3 mr-0.5" />
        <span className="font-medium">{capitalize(chosenColor || '')}</span>
      </div>

      {(product_variant_colors?.length ?? 0) > 1 &&
        scrollContainerRef &&
        setProduct_variant_color &&
        product_variant_colors && (
          <ColorVariantSelector
            scrollContainerRef={scrollContainerRef}
            chosen_product_variant_color_={
              product_variant_colors.find(
                (c) => c.color?.toLowerCase() === chosenColor?.toLowerCase()
              ) || product_variant_colors[0]
            }
            product_variant_colors={product_variant_colors}
            setProduct_variant_color={setProduct_variant_color}
          />
        )}
    </Column>
  )
}
